import { take } from 'rxjs/operators';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import { IAppSettings } from '../models/common-model-interface';
import { ProfileService } from './../services/profile-service.service';
import { NavActiveService } from './../services/nav-active.service';
import { UserRoleService } from './../services/user-role.service';
import { Observable } from 'rxjs';

// import { StorageRefService } from '../services/storage-ref.service';
import { NavigationStoreService, NavigationLink } from '../services/navigation-store.service';
//import { AlertsCountService } from '../services/alerts-count.service';
import { AlertsService } from '../services';

//declare let require: any;
//let $ = require('jquery');

interface AccessChanges extends SimpleChanges {
  accessStatus?: SimpleChange;
}

export interface AlertsConfig {
  alertMessagesUrl?: string;
  alertCountUrl?: string;
  alertMessageReadUrl?: string;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'pru-header',
  templateUrl: './pru-nav.component.html',
  styleUrls: ['./pru-nav.component.scss']
})
export class PruNavComponent implements OnInit, OnChanges {
  @Input()
  logoutFn: Function;
  @Input()
  appName: string;
  @Input()
  accessOptions: string;
  @Input()
  accessStatus: string;
  @Input()
  mainContentId: string;
  @Input()
  alertsConfig: AlertsConfig;

  @Input()
  domain: string | Observable<any>;
  @Input()
  isCustomer: boolean;
  @Output()
  navResponseHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  navUpdateHandler: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  profileName: string;
  @Input()
  userRoles: Observable<string>;

  @Input()
  navJson$: Observable<any>;

  @Input() feedbackSSOId: string;

  userName: string;
  primaryNavs: Array<NavigationLink> = [];
  globalLinks: Array<NavigationLink> = [];
  accountLinks: Array<NavigationLink> = [];
  showMobileHamburgerMenu: boolean;
  hideSecClass: boolean;
  homeUrl: string;
  logoSrc: string;
  registerUrl: string;
  loginUrl: string;
  alertsUrl: string;
  appSettings: IAppSettings = {};

  constructor(
    public profileService: ProfileService,
    public navActiveService: NavActiveService,
    public userRoleService: UserRoleService, // private storageService: StorageRefService
    private navigationStoreService: NavigationStoreService
  ) {
    this.mainContentId = 'mainContent';
  }

  ngOnInit(): void {
    if (this.alertsConfig !== undefined) {
      if (this.alertsConfig.alertMessagesUrl) {
        AlertsService.customApiEndpoint = this.alertsConfig.alertMessagesUrl;
      }

      if (this.alertsConfig.alertMessageReadUrl) {
        AlertsService.customMessageReadEndpoint = this.alertsConfig.alertMessageReadUrl;
      }
    }
    UserRoleService.isCustomer = this.isCustomer;
    this.InitilizeComponent(this.accessOptions);
  }

  InitilizeComponent(accessStatus: string): void {
    this.hideSecClass = true;
    this.appSettings.showLogout = false;
    this.logoutFn = this.logoutFn || this.defaultLogoutFn;
    this.domain = this.domain || '';

    this.getNavigation(this.appName, accessStatus, this.domain, this.userRoles, this.navJson$);
    if (this.profileName !== null && this.profileName !== undefined) {
      this.formatprofile(this.profileName);
    } else {
      this.getUserName(accessStatus, this.domain);
    }
  }

  getNavigation = (
    appName: string,
    accessStatus: string,
    domain,
    userRoles: Observable<string>,
    navJson$: Observable<any>
  ): void => {
    if (navJson$) {
      navJson$.pipe(take(1)).subscribe(navJson => this.navigationStoreService.setData(navJson));
    } else {
      this.navigationStoreService.populateStore(appName, accessStatus, domain, userRoles);
    }

    this.navigationStoreService.getData().subscribe((res: NavigationLink[]) => {
      /*This line of code to give the control on response for pru-header clients*/
      if (res) {
        this.navResponseHandler.emit(res);
        this.showMobileHamburgerMenu = true;
        const appSettingArray = res.find(navLink => navLink.title === 'AppSettingsNav');

        let loginCheck: NavigationLink;
        let homeLinkCheck: NavigationLink;
        let logoLinkCheck: NavigationLink;
        let signUpCheck: NavigationLink;
        let accountLinksCheck: NavigationLink;
        let alertsCheck: NavigationLink;

        if (appSettingArray !== undefined) {
          loginCheck = appSettingArray.children.find(navLink => navLink.title === 'login');
          homeLinkCheck = appSettingArray.children.find(navLink => navLink.title === 'homeurl');
          logoLinkCheck = appSettingArray.children.find(navLink => navLink.title === 'logosrc');
          signUpCheck = appSettingArray.children.find(navLink => navLink.title === 'signup');
          accountLinksCheck = appSettingArray.children.find(
            navLink => navLink.title === 'accountLinks'
          );
          alertsCheck = appSettingArray.children.find(navLink => navLink.title === 'Alerts');

          if (loginCheck) {
            this.appSettings.showLogin = true;
            this.loginUrl = loginCheck.url || '//www.prudential.com/login';
          }

          if (signUpCheck) {
            this.appSettings.showSignup = true;
            this.registerUrl = signUpCheck.url;
          }

          if (accountLinksCheck) {
            this.accountLinks = accountLinksCheck.children || [];
            if (this.accountLinks.length > 0) {
              this.appSettings.showAccount = true;
            }
          }

          if (alertsCheck) {
            this.appSettings.showAlerts = true;
            this.alertsUrl = alertsCheck.url;
          }
        }

        this.homeUrl = homeLinkCheck ? homeLinkCheck.url : '//www.prudential.com';
        if (logoLinkCheck) {
          this.logoSrc = logoLinkCheck.url;
        }

        const primaryNavArray = res.find(navLink => navLink.title === 'PrimaryNav');
        const globalNavArray = res.find(navLink => navLink.title === 'TopNav');

        /* this.primaryNavs = (primaryNavArray && primaryNavArray.children) ?
           this.NavActiveService.activeNav(primaryNavArray.children) : []; */

        this.primaryNavs =
          primaryNavArray && primaryNavArray.children ? primaryNavArray.children : [];
        this.globalLinks = globalNavArray ? globalNavArray.children : [];

        if (this.primaryNavs.length !== 0) {
          let flag = true;
          Object.keys(this.primaryNavs).forEach(index => {
            const primary = this.primaryNavs[index];
            if (
              primary['isActive'] === 'true' &&
              primary['children'] !== undefined &&
              primary['children'] !== null &&
              primary['children'].length > 0
            ) {
              flag = false;
            }
          });
          this.hideSecClass = flag;
        }
      } else {
        this.showMobileHamburgerMenu = false;
      }
    });
  };

  formatprofile(consumerProvidedName: string) {
    this.appSettings.showLogout = true;
    const regex = /(\b)[a-z]/g;
    const firstName = consumerProvidedName.toLowerCase();
    this.userName = firstName.replace(regex, ch => ch.toUpperCase());
  }

  goToMainContent() {
    if (!!this.mainContentId) {
      const focusElementId = <HTMLElement>document.getElementById(this.mainContentId);
      if (!!focusElementId) {
        focusElementId.scrollIntoView();
        focusElementId.setAttribute('tabindex', '-1');
        focusElementId.focus();
      }
    }
  }

  getUserName = (accessStatus, domain): void => {
    let accessOptions = accessStatus.split(',');
    if (accessOptions.length === 2) {
      this.userRoleService.getRoles(accessStatus, domain).subscribe(res => {
        if (res.r !== 'unauth') {
          this.getProfile(domain);
        }
      });
    } else if (/unauth/.test(accessOptions[0])) {
      this.userName = '';
    } else {
      this.getProfile(domain);
    }
  };

  getProfile(domain) {
    this.appSettings.showLogout = true;
    this.profileService.getProfile(domain).subscribe(profile => {
      if (profile.personalInfo && Object.keys(profile.personalInfo).length > 0) {
        this.userName = profile.personalInfo.preferredName
          ? this.getCamelCapName(profile.personalInfo.preferredName)
          : this.getCamelCapName(profile.personalInfo.firstName);
      }
    });
  }

  // getCamelCapName = (personalInfo): string => {
  //   let username = '';
  //   if (personalInfo.preferredName) {
  //     username = personalInfo.preferredName;
  //   } else {
  //     const regex = /(\b)[a-z]/g;
  //     const firstName = personalInfo.firstName.toLowerCase();
  //     username = firstName.replace(regex, ch => ch.toUpperCase());
  //   }

  //   return username;
  // };

  getCamelCapName = (name): string => {
    let username = '';
    const regex = /(\b)[a-z]/g;
    username = name.toLowerCase().replace(regex, ch => ch.toUpperCase());
    return username;
  };

  defaultLogoutFn = () => console.log('Logout Function');

  ngOnChanges(changes: AccessChanges): void {
    if (changes.profileName !== undefined) {
      if (changes.profileName.currentValue !== null) {
        this.formatprofile(this.profileName);
      } else if (changes.profileName.currentValue === null) {
        this.getUserName(this.accessOptions, this.domain);
      }
    }

     if (changes.feedbackSSOId !== undefined) {
       if (changes.feedbackSSOId.currentValue !== null) {
        this.feedbackSSOId = changes.feedbackSSOId.currentValue;
     }
    }

    const isAccessStatusUpdated: SimpleChange = changes.accessStatus;
    if (isAccessStatusUpdated !== undefined) {
      if (isAccessStatusUpdated.currentValue === 'auth') {
        this.appSettings.showSignup = false;
        this.appSettings.showLogin = false;
        this.InitilizeComponent(isAccessStatusUpdated.currentValue);
      }
    }
  }
}
